/**
 * Moldura das telas públicas — entrar, esqueci a senha, redefinir senha,
 * escolha de contexto, "quero atender", passagem do app antigo.
 *
 * Desde 07/10/2026 (A082) é a mesma moldura do cadastro (`MolduraDoCadastro`):
 * o degradê da marca no topo, o logo para fundo colorido sobre ele, o cartão
 * branco e o título em Poppins. Antes era um fundo liso com o logo e um título
 * simples, e a tela de entrar não parecia da mesma família do cadastro, que é
 * para onde ela leva.
 */
import type { ReactNode } from 'react';
import { MolduraDoCadastro, TituloDoCartao } from '../cadastro/novo/kit';

export function AuthFrame({ title, subtitle, children, onBack, rodape }: { title: string; subtitle?: string; children: ReactNode; onBack?: () => void; rodape?: ReactNode }) {
  return (
    <MolduraDoCadastro onBack={onBack} rodape={rodape}>
      <TituloDoCartao titulo={title} subtitulo={subtitle} />
      {children}
    </MolduraDoCadastro>
  );
}
